/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */
const lazyMessages: Record<
	string,
	(() => Promise<{ default: Record<string, string> }>) | undefined
> = {
	cs: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/cs" */ './cs'),
	cs_CZ: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/cs_CZ" */ './cs_CZ'),
	da: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/da" */ './da'),
	da_DK: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/da_DK" */ './da_DK'),
	de: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/de" */ './de'),
	de_DE: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/de_DE" */ './de_DE'),
	en_GB: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/en_GB" */ './en_GB'),
	en_ZZ: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/en_ZZ" */ './en_ZZ'),
	es: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/es" */ './es'),
	fi: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/fi" */ './fi'),
	fi_FI: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/fi_FI" */ './fi_FI'),
	fr: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/fr" */ './fr'),
	fr_FR: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/fr_FR" */ './fr_FR'),
	hu: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/hu" */ './hu'),
	hu_HU: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/hu_HU" */ './hu_HU'),
	it: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/it" */ './it'),
	it_IT: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/it_IT" */ './it_IT'),
	ja: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ja" */ './ja'),
	ja_JP: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ja_JP" */ './ja_JP'),
	ko: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ko" */ './ko'),
	ko_KR: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ko_KR" */ './ko_KR'),
	nb: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/nb" */ './nb'),
	nb_NO: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/nb_NO" */ './nb_NO'),
	nl: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/nl" */ './nl'),
	nl_NL: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/nl_NL" */ './nl_NL'),
	pl: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/pl" */ './pl'),
	pl_PL: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/pl_PL" */ './pl_PL'),
	pt_BR: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/pt_BR" */ './pt_BR'),
	ru: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ru" */ './ru'),
	ru_RU: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/ru_RU" */ './ru_RU'),
	sv: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/sv" */ './sv'),
	sv_SE: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/sv_SE" */ './sv_SE'),
	th: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/th" */ './th'),
	th_TH: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/th_TH" */ './th_TH'),
	tr: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/tr" */ './tr'),
	tr_TR: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/tr_TR" */ './tr_TR'),
	uk: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/uk" */ './uk'),
	uk_UA: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/uk_UA" */ './uk_UA'),
	vi: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/vi" */ './vi'),
	vi_VN: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/vi_VN" */ './vi_VN'),
	zh: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/zh" */ './zh'),
	zh_CN: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/zh_CN" */ './zh_CN'),
	zh_TW: () => import(/* webpackChunkName: "@atlassian/account-menu/locale/zh_TW" */ './zh_TW'),
};
export default lazyMessages;
